import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.scss'
import 'api/config'
import reportWebVitals from './reportWebVitals'
import { WidgetProps } from 'types/widget'
import { Widget } from 'components/Widget'
import { library } from '@fortawesome/fontawesome-svg-core'
import { far } from '@fortawesome/pro-regular-svg-icons'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { API_URL } from './config'
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
library.add(fas, far)
export const widgetProps: WidgetProps = {
  serverApiUrl: API_URL,
  userId: undefined,
  initialPayload: '',
  botAvatar:
    'https://messe-ticket-prod.s3.amazonaws.com/59e90ce61d2d521ffc7c1fb2-image-7ef73177-60cf-4da0-9629-636d0a4af548.jpg',
  widgetColor: '#005CA9',
  textColor: 'white',
  userMsgBackgroundColor: 'rgba(0,92,169,0.7)',
  botTitle: 'SPS Italia',
  botSubTitle: 'Sales & Services Assistant',
  botMsgBackgroundColor: '#f3f4f6',
  chatHeaderCss: {
    textColor: '#FFF',
    backgroundColor: '#005CA9',
    enableBotAvatarBorder: 0,
    avatarStyle: {
      borderRadius: '8px',
    },
  },
  chatHeaderTextColor: '#FFF',
  botMsgColor: '#4b5563',
  userMsgColor: '#FFF',
  buttonsCss: {
    color: '#FFF',
    backgroundColor: 'rgba(0,92,169,0.9)',
    borderColor: '#005CA9',
    borderWidth: '0',
    borderRadius: '999px',
    hoverBackgroundColor: 'rgba(0,92,169,1)',
    hoverColor: '#FFF',
    hoverborderWidth: '0px',
    enableHover: true,
  },
  btnColor: '#005CA9',
  theme: {
    colors: {
      primary: '#005CA9',
      grey: '#4b5563',
      secondary: '#f3f4f6',
      red: '#e3342f',
      green: '#38c172',
    },
  },
}
root.render(
  <React.StrictMode>
    <Widget {...widgetProps} />
  </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
